module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-result"
  }, [(!_vm.searching && _vm.searchResult.length === 0) ? _c('div', {
    staticClass: "empty-search-result inner-x"
  }, [_vm._v("\n    " + _vm._s(_vm.searchState.emptyState) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.searchResult), function(item) {
    return _c('div', {
      staticClass: "inner-x result-item",
      class: {
        active: _vm.isActive(item)
      },
      on: {
        "click": function($event) {
          _vm.handleClick(item)
        }
      }
    }, [_c('span', {
      staticClass: "result-title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), (item.content) ? _c('div', {
      staticClass: "result-content",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }) : _vm._e()])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-a9cc49c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchResult.vue
// module id = 104
// module chunks = 0